import { useContext } from "react";

import { SdkContext, type SdkInstance } from "./sdk-context";

export const useSdk = (): SdkInstance => {
  const context = useContext(SdkContext);

  if (!context) {
    throw new Error("useSdk must be used within an SdkProvider");
  }

  return context.sdk;
};
